import {
  required,
  minLen,
  maxLen,
  maxLenAllowNull,
  pattern,
  dateValidation,
  validateNonexistentDate,
  emailAddress,
  phoneNumberLen,
  validateCountryCode
} from '@/core/_helpers/validationRules.js'
import * as dobColors from '@/config/app/utility/themeUtility'

const getFormConfig = form => {
  if (process.env.NODE_ENV === 'test') {
    return {
      schema: {},
      model: {}
    }
  }
  let ruleState
  if (typeof form === 'object') {
    ruleState = getFormRules(form)
    // Add title if it exists in the form
    if (form.title) {
      ruleState.title = form.title
    }
  }
  return ruleState
}

function getRules (rule, RegEx, length, displayLength) {
  switch (rule) {
    case 'required':
      return required('Required')
    case 'minLen':
      return minLen(length, displayLength)
    case 'maxLen':
      return maxLen(length, displayLength)
    case 'maxLenAllowNull':
      return maxLenAllowNull(length, displayLength)
    case 'phoneNumberLen':
      return phoneNumberLen(length, displayLength)
    case 'dateValidation':
      return dateValidation(length, displayLength)
    case 'emailAddress':
      return emailAddress(RegEx)
    case 'pattern':
      return pattern(RegEx)
    case 'validateNonexistentDate':
      return validateNonexistentDate()
    case 'validateCountryCode' :
      return validateCountryCode(length, displayLength)
    default:
      break
  }
  return null
}
function getFormRules ({ schema, model }) {
  const validationRules = ['required', 'minLen', 'maxLen', 'maxLenAllowNull', 'dateValidation',
    'phoneNumberLen', 'emailAddress', 'validateNonexistentDate', 'validateCountryCode']
  const fSchema = schema

  Object.keys(fSchema).map(schemaKey => {
    const rules = []
    const ruleSet = fSchema[schemaKey].rules

    if (ruleSet) {
      // eslint-disable-next-line no-return-assign
      ruleSet.filter(rule =>
        rule === 'required' ? (fSchema[schemaKey].id = 'required') : false
      )
      ruleSet.filter(rule =>
        validationRules.includes(rule.replace(/[^a-zA-Z]+/g, ''))
          ? rules.push(
            getRules(
              rule.replace(/[^a-zA-Z]+/g, ''),
              rule.replace(/[a-zA-Z()]+/g, ''),
              rule.substring(
                rule.lastIndexOf('(') + 1,
                rule.lastIndexOf(',')
              ),
              rule.substring(rule.lastIndexOf(')'), rule.lastIndexOf(',') + 1)
            )
          )
          : false
      )
    }

    fSchema[schemaKey].rules = rules
    return true
  })

  const data = getFormColors({ model, schema: fSchema })
  return {
    schema: data.schema,
    model: data.model
  }
}

function getFormColors ({ model, schema }) {
  const fSchema = schema

  Object.keys(fSchema).map((schemaKey) => {
    const { color } = fSchema[schemaKey]
    fSchema[schemaKey].color = dobColors[color]
    return true
  })
  return {
    schema: fSchema,
    model
  }
}
export default getFormConfig
